import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { getRegionalProviderBubble, getRegionalProviderDetails, getRegionalProviders } from '../../services/regions'

const BUBBLE_DATA_BASE = [
  { x: 0 },
  { x: 1 },
  { x: 2 },
  { x: 3 },
  { x: 4 },
  { x: 5 },
  { x: 6 },
  { x: 7 },
  { x: 8 },
  { x: 9 },
  { x: 10 },
  { x: 11 }
]
export const RANKING_DICTIONARY = {
  amount: 'indexAmount',
  name: 'indexName',
  oc: 'indexOC',
  rut: 'indexRut',
  status: 'indexStatus'
}

export const GET_REGIONAL_PROVIDERS = 'GET_REGIONAL_PROVIDERS'
export const GET_REGIONAL_PROVIDERS_ERROR = 'GET_REGIONAL_PROVIDERS_ERROR'
export const GET_REGIONAL_PROVIDERS_SUCCESS = 'GET_REGIONAL_PROVIDERS_SUCCESS'
export const onGetRegionalProviders = makeActionCreator(GET_REGIONAL_PROVIDERS)
export const onGetRegionalProvidersError = makeActionCreator(GET_REGIONAL_PROVIDERS_ERROR, 'payload')
export const onGetRegionalProvidersSuccess = makeActionCreator(GET_REGIONAL_PROVIDERS_SUCCESS, 'payload')
export const onGetRegionalProvidersThunk = payload => async dispatch => {
  dispatch(onGetRegionalProviders())

  try {
    const { data } = await getRegionalProviders({
      direction: payload.direction,
      order: payload.order,
      page: payload.page,
      regionId: payload.regionId,
      year: payload.year
    })
    const enhancedData = data.payload?.resultados?.map(item => ({
      amount: item.amountYearlyCLP,
      amountUSD: item.amountYearlyUSD,
      dni: item.supplierRut,
      link: item.link,
      name: item.supplierName,
      orders: item.quantiyYearlyOC,
      ranking: item[RANKING_DICTIONARY[payload.order]] || null,
      tenders: item.quantiyYearlyLIC,
      totalAmount: item.amountYearlyCLPStatus,
      totalAmountUSD: item.amountYearlyUSDStatus
    }))

    return batch(() => {
      dispatch(
        onGetRegionalProvidersSuccess({
          data: enhancedData,
          page: data.payload?.page || 1,
          pages: data.payload?.pageCount || 1,
          records: data.payload?.resultCount || 1
        })
      )
      payload.callback && payload.callback()
    })
  } catch (error) {
    return dispatch(onGetRegionalProvidersError({ error }))
  }
}

export const GET_REGIONAL_PROVIDER = 'GET_REGIONAL_PROVIDER'
export const GET_REGIONAL_PROVIDER_ERROR = 'GET_REGIONAL_PROVIDER_ERROR'
export const GET_REGIONAL_PROVIDER_SUCCESS = 'GET_REGIONAL_PROVIDER_SUCCESS'
export const onGetRegionalProvider = makeActionCreator(GET_REGIONAL_PROVIDER)
export const onGetRegionalProviderError = makeActionCreator(GET_REGIONAL_PROVIDER_ERROR, 'payload')
export const onGetRegionalProviderSuccess = makeActionCreator(GET_REGIONAL_PROVIDER_SUCCESS, 'payload')
export const onGetRegionalProviderThunk = payload => async dispatch => {
  try {
    const [{ data: dataBubble }, { data: dataDetails }] = await Promise.all([
      getRegionalProviderBubble({ dni: payload.dni, regionId: payload.regionId, year: payload.year }),
      getRegionalProviderDetails({ dni: payload.dni, year: payload.year })
    ])
    const bubble = dataBubble.payload?.map(item => ({
      amount: item.amountMonthCLP,
      amountUSD: item.amountMonthUSD,
      id: item.idRegion,
      name: item.supplierName,
      month: item.month,
      orders: item.quantiyMonthOC,
      provider: item.supplierName,
      x: item.monthNumber - 1,
      y: item.amountMonthCLP,
      year: item.year,
      z: item.quantiyMonthOC
    }))
    const enhancedBubble = BUBBLE_DATA_BASE.concat(bubble)
    const pie = dataDetails.payload?.map(item => ({
      amount: item.amountYearlyCLP,
      amountUSD: item.amountYearlyUSD,
      colorName: item.idRegion === payload.regionId ? 'primary' : 'gray2',
      dataLabels: {
        className: item.idRegion === payload.regionId ? 'highlightLabel' : 'simpleLabel'
      },
      id: item.idRegion,
      name: item.region,
      orders: item.quantiyYearlyOC,
      percentage: item.percentage,
      provider: item.supplierName,
      y: item.amountYearlyCLP,
      year: item.year,
      z: item.idRegion === payload.regionId ? 100 : 70
    }))
    const item = dataDetails.payload?.find(item => item.idRegion === payload.regionId) || {}
    const bubbleCsv = [
      ['Año', 'Mes', 'Proveedor', 'Nº de órdenes de compra', 'Monto transado', 'Monto transado (USD)'],
      ...bubble.map(item => [item.year, item.month, item.provider, item.orders, item.amount, item.amountUSD])
    ]
    const pieCsv = [
      ['Año', 'Región', 'Nº de órdenes de compra', 'Monto transado', 'Monto transado (USD)'],
      ...pie.map(item => [item.year, item.name, item.orders, item.amount, item.amountUSD])
    ]

    return batch(() => {
      dispatch(
        onGetRegionalProviderSuccess({
          bubbleCsv,
          pie,
          pieCsv,
          amount: item?.amountYearlyCLP || 0,
          amountUSD: item?.amountYearlyUSD || 0,
          biddings: item?.quantiyYearlyLIC || 0,
          bubble: enhancedBubble,
          orders: item?.quantiyYearlyOC || 0,
          percentage: item?.percentage || 0,
          totalAmount: item?.amountYearlyStatusCLP || 0,
          totalAmountUSD: item?.amountYearlyStatusUSD || 0
        })
      )
      payload.callback && payload.callback()
    })
  } catch (error) {
    return dispatch(onGetRegionalProviderError({ error }))
  }
}
